import React from 'react';

function Historia() {
  return <div className="op-body">Historia</div>;
}

export default Historia;
